function threeDImg(sources, type = 'optimized', elem) {
    if (elem) {
        const canvas = {
            left: document.createElement('canvas'),
            right: document.createElement('canvas'),
            out: document.createElement('canvas')
        };

        canvas.left.id = 'leftcanvas';
        canvas.right.id = 'rightcanvas';
        canvas.out.id = 'outcanvas';
        canvas.left.style.display = 'none';
        canvas.right.style.display = 'none';
        canvas.out.style.display = 'none';
        elem.appendChild(canvas.left);
        elem.appendChild(canvas.right);
        elem.appendChild(canvas.out);

        loadImages(sources, type);
    }
}

function loadImages(sources, type) {
    const images = {};
    let loadedImages = 0;
    let numImages = 2;
    images['left'] = new Image();
    images['right'] = new Image();
    images['left'].onload = runCallback;
    images['right'].onload = runCallback;
    images['left'].src = sources['left'];
    images['right'].src = sources['right'];

    function runCallback() {
        if (++loadedImages >= numImages) {
            threeDRender(images, type);
        }
    }
}

function threeDRender(images, type) {
    const canvas = {
        left: document.getElementById('leftcanvas'),
        right: document.getElementById('rightcanvas'),
        out: document.getElementById('outcanvas')
    };

    const ctx = {
        left: canvas.left.getContext('2d'),
        right: canvas.right.getContext('2d'),
        out: canvas.out.getContext('2d')
    };

    const anMatrices = {
        optimized: {
            left: [[0, 0.7, 0.3], [0, 0, 0], [0, 0, 0]],
            right: [[0, 0, 0], [0, 1, 0], [0, 0, 1]]
        },
        true:
            {
                left: [[0.299, 0.587, 0.114], [0, 0, 0], [0, 0, 0]],
                right: [[0, 0, 0], [0, 0, 0], [0.299, 0.587, 0.114]]
            },
        grey:
            {
                left: [[0.299, 0.587, 0.114], [0, 0, 0], [0, 0, 0]],
                right: [[0, 0, 0], [0.299, 0.587, 0.114], [0.299, 0.587, 0.114]]
            },
        color:
            {
                left: [[1, 0, 0], [0, 0, 0], [0, 0, 0]],
                right: [[0, 0, 0], [0, 1, 0], [0, 0, 1]]
            },
        halfcolor:
            {
                left: [[0.299, 0.587, 0.114], [0, 0, 0], [0, 0, 0]],
                right: [[0, 0, 0], [0, 1, 0], [0, 0, 1]]
            },
        dubois:
            {
                left: [[0.437, 0.449, 0.164], [-0.062, -0.062, -0.024], [-0.048, -0.050, -0.017]],
                right: [[-0.011, -0.032, -0.007], [0.377, 0.761, 0.009], [-0.026, -0.093, 1.234]]
            }
    };

    let an;
    switch (type) {
    case 'optimized':
    default:
        an = anMatrices.optimized;
        break;
    case 'true':
        an = anMatrices.true;
        break;
    case 'grey':
        an = anMatrices.grey;
        break;
    case 'color':
        an = anMatrices.color;
        break;
    case 'halfcolor':
        an = anMatrices.halfcolor;
        break;
    case 'dubois':
        an = anMatrices.dubois;
        break;
    }

    canvas.left.width = canvas.right.width = canvas.out.width = images.left.width;
    canvas.left.height = canvas.right.height = canvas.out.height = images.left.height;

    ctx.left.drawImage(images.left, 0, 0);
    ctx.right.drawImage(images.right, 0, 0);
    images.out = new Image();

    let imageData = {
        left: ctx.left.getImageData(0, 0, canvas.left.width, canvas.left.height),
        right: ctx.right.getImageData(0, 0, canvas.right.width, canvas.right.height),
        out: ctx.out.createImageData(canvas.left.width, canvas.left.height)
    };

    for (let idx = 0; idx < imageData.left.data.length; idx += 4) {
        const pix = {
            left: [imageData.left.data[idx], imageData.left.data[idx + 1], imageData.left.data[idx + 2]],
            right: [imageData.right.data[idx], imageData.right.data[idx + 1], imageData.right.data[idx + 2]]
        };
        const v = {
            left: matrix_vec(an.left, pix.left),
            right: matrix_vec(an.right, pix.right)
        };
        const pixAn = vec_add(v.left, v.right);
        imageData.out.data[idx] = pixAn[0];
        imageData.out.data[idx + 1] = pixAn[1];
        imageData.out.data[idx + 2] = pixAn[2];
        imageData.out.data[idx + 3] = 255;
    }

    //output the image
    let placeholder = document.querySelector('.imgPlaceholder');
    //    placeholder.style.display = 'none';
    placeholder.parentNode.removeChild(placeholder);
    canvas.left.parentNode.removeChild(canvas.left);
    canvas.right.parentNode.removeChild(canvas.right);
    ctx.out.putImageData(imageData.out, 0, 0);
    canvas.out.style.display = 'block';


    function matrix_vec(m = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], v = [0, 0, 0]) {
        let out = [0, 0, 0];
        for (let i = 0; i < 3; ++i) {
            for (let j = 0; j < 3; ++j) {
                out[i] = out[i] + (v[j] * m[i][j]);
            }
        }
        return (out);
    }

    function vec_add(v1 = [0, 0, 0], v2 = [0, 0, 0]) {
        let out = [0, 0, 0];
        for (let i = 0; i < 3; ++i) {
            out[i] = v1[i] + v2[i];
        }
        return (out);
    }
}

export default threeDImg;
